import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaRobot, FaChartLine, FaCogs, FaUsers, FaPhone, FaEnvelope, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { MdAutoFixHigh, MdSpeed, MdSecurity } from 'react-icons/md';

// ISPRAVNI IMPORTI - bez './components/' jer ste već u components folderu
import Header from './Header';
import Hero from './Hero';
import SocialProof from './SocialProof';
import Features from './Features';
import Services from './Services';
import DemoExamples from './DemoExamples';
import HowItWorks from './HowItWorks';
import Guarantee from './Guarantee';
import Pricing from './Pricing';
import FAQ from './FAQ';
import BookCall from './BookCall';
import Footer from './Footer';

// Glavna komponenta koja sadrži ceo sajt
const EagleAIWebsite = () => {
  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <Header />
      <Hero />
      <SocialProof />
      <Features />
      <Services />
      <DemoExamples />
      <HowItWorks />
      <Guarantee />
      <Pricing />
      <FAQ />
      <BookCall />
      <Footer />
    </div>
  );
};

export default EagleAIWebsite;